import Typography, { type TypographyProps } from '@mui/material/Typography'

export { MultilineTypography }

type Props = TypographyProps & {
  text?: string
}

/**
 * A props-extendable typography component that displays text with preserved
 * line breaks.
 */
const MultilineTypography = ({ text = '', ...rest }: Props) => {
  return (
    <Typography
      {...rest}
      sx={{ fontSize: 'inherit', ...rest.sx, whiteSpace: 'pre-line' }}
    >
      {text}
    </Typography>
  )
}
